import * as Strings from '../utils/sensitivityMenu.locstring.json';
import { confirm } from 'owa-confirm-dialog';
import loc from 'owa-localize';
import type { ComposeViewState } from 'owa-mail-compose-store';
import { save } from 'owa-mail-compose-command';
import removeInfoBarMessage from 'owa-info-bar/lib/actions/removeInfoBarMessage';
import { lazyShowJustificationModal } from 'owa-mail-protection';
import setIRMData from 'owa-mail-protection/lib/actions/rms/setIRMData';
import type CLPLabel from 'owa-mail-protection-types/lib/schema/CLPLabel';

export default function onSensitivity(
    viewState: ComposeViewState,
    label: CLPLabel,
    targetWindow?: Window
) {
    if (viewState === undefined) {
        return;
    }

    const { protectionViewState } = viewState;
    const { clpViewState, IRMData } = protectionViewState;
    const isReplyOrForward = viewState.referenceItemId ? true : false;

    const tgtWindow: Window = targetWindow ?? window;

    if (IRMData && !IRMData.IsOwner) {
        confirm(
            loc(Strings.clpLabelCannotChangeLabelModalTitle), // Modal Title
            loc(Strings.clpLabelCannotChangeLabelModalSubtext), // Subtext
            false, // Resolve immediately
            { hideCancelButton: true, targetWindow } // Custom Confirmation Options
        );
        return;
    }

    if (
        label.isEncryptingLabel &&
        (viewState.attachmentWell.docViewAttachments?.some(attachment => attachment.isCloudy) ||
            viewState.attachmentWell.imageViewAttachments?.some(attachment => attachment.isCloudy))
    ) {
        confirm(
            loc(Strings.clpLabelCannotChangeLabelModalTitle),
            loc(Strings.clpLabelCannotChangeLabelWithCloudAttachment),
            false /* Resolve immediately */,
            {
                targetWindow,
                hideCancelButton: true,
            }
        );
        return;
    }

    removeInfoBarMessage(viewState, 'CLPAutoLabelAutomatic');
    removeInfoBarMessage(viewState, 'CLPAutoLabelRecommended');

    lazyShowJustificationModal.import().then(showJustificationModal => {
        showJustificationModal(label, viewState, clpViewState, isReplyOrForward, tgtWindow).then(
            isLabelChanged => {
                if (isLabelChanged) {
                    if (label.isEncryptingLabel) {
                        removeInfoBarMessage(viewState, 'irmInfoBar');
                        setIRMData(viewState.protectionViewState, null);
                    }

                    // if label is changed it is needed to save the draft to trigger the DLP Policy.
                    // isAutoSave is false to force saving.
                    save(viewState, false /*isAutoSave*/);
                }
            }
        );
    });
}
